<template>
  <div class="contact-table">
<!--    <h2>投资者热线</h2>-->
    <table>
      <thead>
      <tr>
        <th>信息类别</th>
        <th>详细信息</th>
      </tr>
      </thead>
      <tbody>
      <tr>
        <td>联系电话</td>
        <td>028-87888068</td>
      </tr>
      <tr>
        <td>联系邮箱</td>
        <td>jiachizqb@cdjc.com.cn</td>
      </tr>
      <tr>
        <td>传真</td>
        <td>028-87888068</td>
      </tr>
      <tr>
        <td>公司地址</td>
        <td>成都市郫都区成都现代工业港南片区新经济产业园文明街西段288号</td>
      </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
export default {
  name: 'Announcements',
  mounted() {
    window.open('https://www.sse.com.cn/home/search/index.shtml?webswd=%E4%BD%B3%E9%A9%B0%E7%A7%91%E6%8A%80', '_blank');
    this.$router.push({ name: '投资者热线' });
  }
}
</script>

<style scoped>
.contact-table {
  width: 70%;
  margin: 40px auto;
  font-family: Source Han Sans CN;
  background: #fff;
  border-radius: 10px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  padding: 30px;
}

h2 {
  text-align: center;
  font-size: 28px;
  color: #333;
  margin-bottom: 30px;
  font-weight: bold;
}

table {
  width: 100%;
  border-collapse: collapse;
}

th, td {
  padding: 15px;
  text-align: left;
  font-size: 16px;
  color: #555;
}

th {
  background-color: #f6f6f6;
  font-weight: 600;
  text-transform: uppercase;
  color: #333;
}

tbody tr {
  border-bottom: 1px solid #f0f0f0;
}

tbody tr:hover {
  background-color: #f1f8ff;
  cursor: pointer;
}

tbody tr:nth-child(even) {
  background-color: #f9f9f9;
}

tbody td {
  background-color: #fafafa;
  border-radius: 8px;
}

td:last-child {
  color: #007BFF;
}

table, th, td {
  border: 1px solid #ddd;
  border-radius: 8px;
}

table {
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
}

table th, table td {
  transition: all 0.3s ease;
}

table th:hover {
  background-color: #f4f4f4;
}
</style>
